/**
 * The connect page. The Squiryl integration is the <squiryl-button> element and
 * the four events below — everything else here is Northwind's own presentation.
 */
import '@squiryl/button';

const btn = document.querySelector('squiryl-button');
const statusEl = document.getElementById('status');
const errorEl = document.getElementById('share-error');
const linkedEl = document.getElementById('linked');
const detailsEl = document.getElementById('linked-details');

const LABELS = {
  first_name: 'First name', last_name: 'Last name',
  line_1: 'Address', line_2: 'Address line 2', city: 'Town or city', county: 'County',
  province_code: 'Region', postcode: 'Postcode', country: 'Country',
  email: 'Email', phone_number: 'Phone',
};
const label = (key) => LABELS[key] ?? key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// The payload comes out of someone's vault, so it is untrusted text as far as
// this page is concerned. Escape before it goes anywhere near innerHTML.
const esc = (value) =>
  String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

function renderDetails(payload) {
  const rows = [];
  for (const [section, fields] of Object.entries(payload)) {
    if (!fields || typeof fields !== 'object' || section === 'captured_at') continue;
    for (const [field, value] of Object.entries(fields)) {
      if (value === null || value === undefined || value === '') continue;
      rows.push(`<dt>${esc(label(field))}</dt><dd>${esc(value)}</dd>`);
    }
  }
  detailsEl.innerHTML = rows.join('') || '<dt>Nothing shared</dt><dd class="empty">—</dd>';
}

btn.addEventListener('squiryl:statechange', (event) => {
  const state = event.detail.state;
  const text = {
    idle: 'Press the button, then approve on your phone.',
    creating: 'Preparing a request…',
    waiting: 'Waiting for you to approve in the Squiryl app…',
    delivered: 'Approved.',
  };
  statusEl.textContent = text[state] ?? `state: ${state}`;
});

btn.addEventListener('squiryl:share', (event) => {
  const { payload, kyc_verified } = event.detail;

  // The consent can succeed while the encrypted window fails to arrive — the key
  // delivery is a separate, asynchronous webhook. Say so rather than showing null.
  if (!payload || Object.keys(payload).length === 0) {
    errorEl.hidden = false;
    errorEl.innerHTML =
      '<p><strong>You approved, but the encrypted details never reached this server.</strong></p>' +
      '<p>That means the contract key webhook could not be delivered to us. Nothing was lost — ' +
      'try again, or contact support with the time you tried.</p>';
    return;
  }

  statusEl.innerHTML = `Connected${kyc_verified ? ' — verified account holder' : ''}.`;
  renderDetails(payload);
  linkedEl.hidden = false;
  linkedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
});

btn.addEventListener('squiryl:declined', () => {
  statusEl.textContent = 'You declined the request. Nothing was shared.';
});
btn.addEventListener('squiryl:expired', () => {
  statusEl.textContent = 'The request expired. Press the button to try again.';
});
btn.addEventListener('squiryl:error', (event) => {
  statusEl.textContent = `Something went wrong: ${event.detail.error}`;
});
